import { render } from "./OverlayRoomConfigButton.vue?vue&type=template&id=59a1932a&scoped=true"
import script from "./OverlayRoomConfigButton.vue?vue&type=script&lang=js"
export * from "./OverlayRoomConfigButton.vue?vue&type=script&lang=js"

import "./OverlayRoomConfigButton.vue?vue&type=style&index=0&id=59a1932a&scoped=true&lang=scss"

import exportComponent from "/Users/vladimirkurockin/Projects/NowMedia/wardrobe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59a1932a"]])

export default __exports__